import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { GetLanguage } from '../../utils/language';
import i18next from 'i18next';
import { toDisplayDecimal } from '../../utils';
import styles from '../../styles/schedule.module.css';

const useStyles = makeStyles({
    table: {
    },
    detail: {
        textAlign: 'left',
        '& > div': {
            padding: '6px'
        }
    }
});

export default function ScheduleSummaryDetailPlanif(props) {
    const classes = useStyles();
    const [dataScheduler, setDataScheduler] = React.useState(null);
    const [data, setData] = React.useState(null);

    useEffect(() => {
        if (props.data !== null && props.data !== undefined) {
            setData(props.data);
            const list = [];
            list.push(props.data);

            setDataScheduler(list);
        }
    }, []);

    return (
        <List>
            {dataScheduler != null && dataScheduler.map((obj, index) =>
                <React.Fragment key={index}>
                    <ListItem key={index}>
                        <ListItemText primary={obj.display + ' (' + toDisplayDecimal(Math.round(obj.startHour * 100) / 100) + ' - ' + toDisplayDecimal(Math.round(obj.endHour * 100) / 100) + ')'} secondary={
                            <React.Fragment>
                                <span className={styles.listSubtitle1}>
                                    {i18next.t('schedule:list.from') + ' ' + toDisplayDecimal(Math.round(obj.startHour * 100) / 100) + ' ' + i18next.t('schedule:list.to') + ' ' + toDisplayDecimal(Math.round(obj.endHour * 100) / 100)}
                                </span>

                                {obj.mealMinsCentieme != null && obj.mealMinsCentieme != '' && obj.mealMinsCentieme != 0 ? (
                                    <span className={styles.listSubtitle1}>
                                        {`${i18next.t('schedule:list.meal')}${i18next.t('common:labelSeparator')} ${i18next.t('schedule:list.from')}` + ' ' + toDisplayDecimal(Math.round(obj.mealStart * 100) / 100) + '  ' + i18next.t('schedule:list.to') + ' ' + toDisplayDecimal(Math.round(obj.mealEnd * 100) / 100) + ' (' + toDisplayDecimal(Math.round(obj.mealMinsCentieme * 100) / 100) + ')'}
                                    </span>
                                ) : null}

                                <span className={styles.listSubtitle1}>
                                    {`${i18next.t('schedule:list.shift')}${i18next.t('common:labelSeparator')} ${obj.shiftCode}` + ' - ' + (GetLanguage() == 'fr' ? obj.shiftDescriptionF : obj.shiftDescriptionE)}
                                </span>
                                <span className={styles.listSubtitle1}>
                                    {`${i18next.t('schedule:list.department')}${i18next.t('common:labelSeparator')} ${obj.department}` + ' - ' + (GetLanguage() == 'fr' ? obj.departmentDescriptionF : obj.departmentDescriptionE)}
                                </span>
                                <span className={styles.listSubtitle1}>
                                    {`${i18next.t('schedule:list.jobTitle')}${i18next.t('common:labelSeparator')} ${obj.jobTitle}` + ' - ' + (GetLanguage() == 'fr' ? obj.jobTitleDescriptionF : obj.jobTitleDescriptionE)}
                                </span>

                                {obj.project != null && obj.project != '' ? (
                                    <span className={styles.listSubtitle1}>
                                        {`${i18next.t('schedule:list.project')}${i18next.t('common:labelSeparator')} ${obj.project}` + ' - ' + (GetLanguage() == 'fr' ? obj.projectDescriptionF : obj.projectDescriptionE)}
                                    </span>
                                ) : null}

                                {obj.otherClassification != null && obj.otherClassification != '' ? (
                                    <span className={styles.listSubtitle1}>
                                        {`${i18next.t('schedule:list.otherClassification')}${i18next.t('common:labelSeparator')} ${obj.otherClassification}` + ' - ' + (GetLanguage() == 'fr' ? obj.otherClassificationDescriptionF : obj.otherClassificationDescriptionE)}
                                    </span>
                                ) : null}
                            </React.Fragment>
                        } />
                    </ListItem>
                </React.Fragment>
            )}
        </List>
    );
}